import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class RepresentativesVisits  {
    _originalTypeClassName = "zERP.BO.RepresentativesVisits";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
RepresentativesVisits.translate = translateService;
}
this.Id = null;
this.Date = null;
this.Reason = null;
this.Notes = null;
this.Type = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Date:any;
Reason:any;
Notes:any;
Type:any;
Address:any;
Representative:any;
static setAddress = ($this, value) => {
var oldValue = $this.Address;
$this.Address = value;
if (value != null) {
}
}
static setRepresentative = ($this, value) => {
var oldValue = $this.Representative;
$this.Representative = value;
if (value != null) {
if (oldValue != null) {
Domain.Representative.removeRepresentativesVisits(oldValue, $this);
}
Domain.Representative.addRepresentativesVisits(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}